import React from 'react';
import { getVimeoId, getYoutubeId } from '@assets/ts/videoEmbed';
export const VideoEmbed = (props) => {
    const { url, source } = props;
    switch (source) {
        case ('youtube'):
            return React.createElement(VideoEmbedYoutube, { url: url });
        case ('vimeo'):
            return React.createElement(VideoEmbedVimeo, { url: url });
    }
};
const VideoEmbedYoutube = ({ url }) => {
    const videoId = getYoutubeId(url);
    if (videoId) {
        return React.createElement("div", { className: 'video-embed-wrap' },
            React.createElement("iframe", { src: `https://www.youtube.com/embed/${videoId}`, title: "YouTube video player", frameBorder: "0", allow: `accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share`, allowFullScreen: true }));
    }
    else {
        return React.createElement("h1", { style: { textAlign: 'center', background: '#ececec' } }, "Neteisinga Youtube nuoroda");
    }
};
const VideoEmbedVimeo = ({ url }) => {
    const videoId = getVimeoId(url);
    if (videoId) {
        return React.createElement("div", { className: 'video-embed-wrap' },
            React.createElement("iframe", { src: `https://player.vimeo.com/video/${videoId}`, title: "YouTube video player", frameBorder: "0", allow: `fullscreen; picture-in-picture`, allowFullScreen: true }));
    }
    else {
        return React.createElement("h1", { style: { textAlign: 'center', background: '#ececec' } }, "Neteisinga Vimeo nuoroda");
    }
};
